module.exports = __webpack_public_path__ + "static/img/add-geometry.ec9f5152.svg";